import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

import { APP_PRIMARY } from 'colours';

/**
 * Component displaying menu for traits groups.
 * @param {Component properties} props
 */
export default function TraitGroupsMenu(props) {
  const [currentTrait, setCurrentTrait] = useState(props.selIx);
  const useStyles = makeStyles(theme => ({
    traitGroupMenu: {
      fontFamily: 'MuseoSans-500',
      fontSize: 12,
      lineHeight: 1.21,
      color: 'white',
    },
  }));

  useEffect(() => setCurrentTrait(props.selIx), [props.selIx]);

  const classes = useStyles();

  const onIconClicked = ix => {
    if (props.onIconClicked) {
      setCurrentTrait(ix);
      props.onIconClicked(ix);
    }
  };

  return (
    <Grid container direction="row" justify="center" alignItems="center">
      {props.items.map((item, ix) => {
        return (
          <Grid
            key={ix}
            item
            xs
            style={{
              maxWidth: ix === currentTrait ? '60%' : '10%',
              backgroundColor: ix === currentTrait ? APP_PRIMARY : 'white',
              color: ix === currentTrait ? 'white' : APP_PRIMARY,
            }}
            onClick={() => {
              onIconClicked(ix);
            }}
          >
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
            >
              <Grid>
                {ix === currentTrait ? (
                  <Grid
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                  >
                    <Grid item>
                      {React.cloneElement(item.icon, { fill: 'white' })}
                    </Grid>
                    <Grid item>
                      <span className={classes.traitGroupMenu}>
                        {props.groups.find(g => g.code === item.code).name}
                      </span>
                    </Grid>
                  </Grid>
                ) : (
                  <span> {React.cloneElement(item.icon)}</span>
                )}
              </Grid>
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
}

TraitGroupsMenu.propTypes = {
  /**
   * Indicates which menu item needs to be displayed as selected. Zero based index.
   */
  selIx: PropTypes.number,
};
